import { Badge, BadgeProps, styled } from '@mui/material';

export const styledPdfListWrapper = {
  flex: 1,
  overflow: 'auto',
  height: '100%',
  mt: 2,
};

export const styledSortFilterZone = {
  position: { xs: 'fixed', sm: 'initial' },
  top: { xs: '0', sm: 'initial' },
  left: { xs: '0', sm: 'initial' },
  height: { xs: '100vh', sm: '100%' },
  width: { xs: '100vw', sm: 250, lg: 350 },
  zIndex: { xs: '1200', sm: 'initial' },
  display: 'flex',
  flexDirection: 'column',
  p: 2,
  ml: { xs: 0, sm: 2 },
};

export const styledSortFilterZoneCollapse = {
  height: '100%',
};

export const styledSortFilterZoneContent = {
  flex: 1,
};

export const styledScrollingZone = {
  height: '100%',
  overflow: 'auto',
};

export const styledPdfDocumentsList = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  py: 1,
  px: { xs: 1, sm: 3 },
  height: '100%',
};

export const styledPdfListAction = {
  display: 'flex',
  justifyContent: 'center',
};

export const styledCategorySelector = {
  display: 'flex',
  alignItems: 'center',
  pb: 1,
  borderBottom: 1,
  borderColor: 'grey.500',
};

export const styledCategoriesList = {
  display: 'flex',
  flexGrow: 1,
  overflow: 'auto',
  mx: 2,
  '&::-webkit-scrollbar': {
    display: 'none',
  },
};

export const styledSynchronizationItem = {
  mr: 2,
  minWidth: 'fit-content',
};

export const styledSelectorIcon = {
  alignItems: 'center',
  display: 'flex',
  gap: 1,
};

export const StyledBadge = styled(Badge)<BadgeProps & { selected?: boolean }>(({ theme, selected }) => {
  return {
    '& .MuiBadge-badge': {
      right: 'initial',
      position: 'relative',
      top: 12,
      marginLeft: theme.spacing(0.5),
      transform: 'scale(1) translate(0, -50%)',
      color: selected ? theme.palette.primary.main : theme.palette.primary.contrastText,
      backgroundColor: selected ? theme.palette.primary.contrastText : theme.palette.primary.main,
      fontWeight: 700,
    },
  };
});

export const styledLoadMoreButton = {
  mt: 4,
  mb: { xs: 4 },
  width: ['100%', '60%'],
  minWidth: 200,
};

export const versionSelector = {
  width: ['100%', 'initial'],
};

export const versionSelectorButton = {
  flex: [1, 'initial'],
  minWidth: 'fit-content',
  p: '0 5px',
};

export const styledPdfDocumentCards = {
  display: 'grid',
  gridTemplateColumns: ['repeat(auto-fill, minmax(150px, 1fr))','repeat(auto-fill, minmax(180px, 1fr))'],
  columnGap: ['14px','18px'],
  rowGap: ['14px','18px'],
};
